import { GridCellProps } from '@progress/kendo-react-grid';
import { Input, InputProps } from '@progress/kendo-react-inputs';
import { trim } from 'lodash';
import { SyntheticEvent, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';
import GridCellBase from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import useRenameFileApi from 'src/services/useRenameFileApi';
const RenameFile = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { latestClickedId, setLatestClickedId, refreshList } = cellClick?.(null);
  const { dataItem, field = '' } = props;
  const { attachId } = dataItem;

  const { onChange, dataIndex } = props;
  const openEdit = useCallback(() => setLatestClickedId(attachId), [attachId, setLatestClickedId]);
  const closeEdit = useCallback(() => setLatestClickedId(0), [setLatestClickedId]);
  const isEditable = attachId === latestClickedId;
  const { renameFile } = useRenameFileApi(dataItem.isInvoices);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const extension = useMemo(() => dataItem?.description?.split('.').at(-1), [dataItem.description]);

  const handleBlur = useCallback(async () => {
    const value = trim(dataItem[field]);
    if (value && !(value === `.${extension}`)) {
      if (value?.endsWith(extension)) {
        await renameFile([
          {
            attachId: attachId,
            name: value,
          },
        ]);
      } else {
        toast.error('Please provide the same file extension');
      }
    } else {
      toast.error('Please provide valid file name');
    }

    closeEdit();
    refreshList();
  }, [dataItem, field, closeEdit, refreshList, extension, renameFile, attachId]);

  const handleChange = useCallback(
    (e: InputProps) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e as SyntheticEvent,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  useEffect(() => {
    if (inputRef?.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <GridCellBase onClick={!isEditable ? openEdit : undefined} title={dataItem[field]} {...props}>
      {isEditable ? (
        <Input value={dataItem[field]} onBlur={handleBlur} onChange={handleChange} ref={inputRef} />
      ) : (
        <span>{dataItem[field]}</span>
      )}
    </GridCellBase>
  );
};

export default RenameFile;
